module.exports = __webpack_public_path__ + "static/media/valida.a38aaf7b.webp";